"use client";

import React from "react";
import GenericSubstantiveProcedures from "../../substantive-procedures/GenericSubstantiveProcedures";

interface TradePayablesSubstantiveProceduresProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
}

const WORKSPACE_NAME = "Trade Payables";

export default function TradePayablesSubstantiveProcedures({ onBack, setActiveSection }: TradePayablesSubstantiveProceduresProps) {
  return (
    <GenericSubstantiveProcedures
      workspaceName={WORKSPACE_NAME}
      area="Execution"
      onBack={onBack}
      setActiveSection={setActiveSection}
    />
  );
}
